import { useAppSelector } from 'src/hooks';
import * as Plotly from 'plotly.js';
import Plot from 'react-plotly.js';

export default function BarChartWithoutAxis({
  barWidthValue,
  barData,
  zoom,
  hover,
  axisKeys,
  height,
  hideAxis
}: {
  barWidthValue: number;
  // barData: BarChartDetails;
  barData: any;
  zoom: boolean;
  hover: boolean;
  axisKeys: { key: string; alias: string; color: string }[];
  height: number;
  hideAxis: boolean;
  }) {
  const { summaryMetrics:{modules} } = useAppSelector((state) => state.summary);
  const yAxis: string[] = [];
  const xAxis: number[] = [];
  axisKeys.reverse().forEach((axisData) => {
    xAxis.push(barData[axisData.key]);
    yAxis.push(axisData.key);
  });
  const yData = modules.map((module) => module.alias);
  const xData = new Array(yData.length).fill(-0);

  const plotData: Plotly.Data = {
    type: 'bar',
    x: xData,
    y: yData,
    orientation: 'h',
    yAxis: 'y2',
    width: 0.4,
    name: '',
    // name: axisKeys.map((axisData) => axisData.alias),
    marker: {
      color: axisKeys.map((axisData) => axisData.color)
    }
    // text: [
    //   {
    //     x: barData[axisName.key] ? abbreviateNumber(barData[axisName.key]) : 0
    //   } as any
    // ],
    // hovertemplate: `<extra></extra>${axisName.alias}: <b>%{text.x}</b>`
  };

  const layout: Partial<Plotly.Layout> = {
    xaxis: {
      autorange: true,
      showgrid: false,
      zeroline: false,
      showline: false,
      autotick: true,
      ticks: '',
      showticklabels: false,
      xanchor: 'left'
    },
    yaxis: {
      showgrid: false,
      showline: false,
      zeroline: false,
      anchor: 'free',
      position: 0,
      side: 'right'
    },
    margin: {
      l: 0,
      t: 0,
      b: 0
    },
    plot_bgcolor: '#F9F9F9',
    paper_bgcolor: '#F9F9F9',
    height,
    bargap: 0,
    width: barWidthValue,
    title: '',
    dragmode: false,
    showlegend: false
    // hoverlabel: {
    //   bgcolor: '#f3f3f3',
    //   align: 'left'
    // }
  };

  return (
    <Plot
      data={[plotData]}
      layout={layout}
      config={{ displayModeBar: false }}
    />
  );
}
